/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Form, Row, Col, FormGroup, Label, Container } from 'reactstrap';
import '../../styles/chord-shift.css';

import ChordshiftIcon from '../../assets/icons/chord-shift-button.svg';
import ChordshiftIconMember from '../../assets/icons/chord-shift-button-member.svg';
import CommonButton from './CommonButton';
import { Handler } from '../../common/handler';

const ChordShiftButton = ({
    showDialog,
    onClick,
    handler,
    isMember,
}: {
    showDialog?: boolean;
    onClick?: () => void;
    handler: Handler | null;
    isMember: boolean;
}) => {
    const [show, setShowDialog] = useState<boolean>(false);
    const [currentChord, setChord] = useState<string>('none');
    const [risingMajor] = useState<Array<string>>(['C', '#C', 'D', 'E', '#F', 'G', 'A', 'B']);
    const [reduceMajor] = useState<Array<string>>(['bD', 'bE', 'F', 'bG', 'bA', 'bB', 'bC']);
    const TONE_PITCH = 'tone_pitch';
    const INIT_TONE_PITCH = 'init_tone_pitch'

    useEffect(() => {
        const tone_pitch = localStorage.getItem(TONE_PITCH);
        if (!tone_pitch) {
            localStorage.setItem(TONE_PITCH, 'none');
            handler && handler.redraw();
        } else {
            setChord(swapChars(tone_pitch));
        }
    }, []);

    useEffect(() => {
        if (!showDialog) {
            setShowDialog(false);
        }
    }, [showDialog]);

    const swapChars = (str: string) => {
        if (str.length === 2) {
            // 使用数组解构交换字符顺序
            return str[1] + str[0];
        } else {
            // 如果长度不为2，则返回原始字符串
            return str;
        }
    };

    return (
        <div className="chord-shift">
            <button
                className="right-button"
                onClick={() => {
                    onClick && onClick();
                    setShowDialog(!show);
                }}
            >
                <img src={isMember ? ChordshiftIconMember : ChordshiftIcon} alt="save-icon" />
            </button>
            {showDialog && show && (
                <div className="dialog">
                    <Container>
                        <Form className="chord-shift-form">
                            <FormGroup noMargin>
                                <Label size="sm">调号</Label>
                                <FormGroup noMargin>
                                    <CommonButton
                                        title="无升降调"
                                        type={currentChord === 'none' ? 'active' : 'normal'}
                                        onClick={() => {
                                            setChord('none');
                                            localStorage.setItem(TONE_PITCH, 'none');
                                            handler && handler.init();
                                        }}
                                    />
                                </FormGroup>
                            </FormGroup>
                            <>
                                {/* 升号系列大调 */}
                                <Row className="mb-2">
                                    <Label size="sm" sm={12}>
                                        升号系列大调
                                    </Label>
                                    {risingMajor.map((major: string) => (
                                        <Col key={major} md={6} className="mb-2">
                                            <CommonButton
                                                title={major + '大调'}
                                                type={currentChord === major ? 'active' : 'normal'}
                                                onClick={() => {
                                                    setChord(major);
                                                    localStorage.setItem(TONE_PITCH, swapChars(major));
                                                    if (!localStorage.getItem(INIT_TONE_PITCH)) {
                                                        localStorage.setItem(INIT_TONE_PITCH, swapChars(major));
                                                    }
                                                    handler && handler.init();
                                                }}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </>
                            <>
                                {/* 降号系列大调 */}
                                <Row className="mb-2">
                                    <Label size="sm" sm={12}>
                                        降号系列大调
                                    </Label>
                                    {reduceMajor.map((major: string) => (
                                        <Col key={major} md={6} className="mb-2">
                                            <CommonButton
                                                title={major + '大调'}
                                                type={currentChord === major ? 'active' : 'normal'}
                                                onClick={() => {
                                                    setChord(major);
                                                    localStorage.setItem(TONE_PITCH, swapChars(major));
                                                    if (!localStorage.getItem(INIT_TONE_PITCH)) {
                                                        localStorage.setItem(INIT_TONE_PITCH, swapChars(major));
                                                    }
                                                    handler && handler.redraw();
                                                }}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        </Form>
                    </Container>
                </div>
            )}
        </div>
    );
};

export default ChordShiftButton;
